import BookingConfirmation from '../components/Confirmation'

const Confirmation = () => <BookingConfirmation />

export default Confirmation
